import N8nSegmentControl from './SegmentControl.vue';

export type {
	SegmentControlProps,
	SegmentControlSize,
	SegmentOption,
} from './SegmentControl.types';
export default N8nSegmentControl;
